import type { Resource } from '../../';
export const country_countries_PL: Resource = {"default":"Poland"};
